export default __webpack_public_path__ + "static/media/qris.efa4f2f8.svg";